<template>
  <div id="productShowDetail">
      <!--人寿团意-->

      <div :class="this.showType == 1? 'show' : 'dis'">
        <div >
          <div class="life-top"  @click="handleOpen(1)"></div>
          <div class="life-one"></div>
          <div class="life-two"></div>
          <div class="life-three"></div>
        </div>
      </div>
      <!--关税-->
      <div :class="this.showType == 2 ? 'show' : 'dis'">
        <div >
          <div class="tariff-top" @click="handleOpen(2)"></div>
          <div class="tariff-one"></div>
          <div class="tariff-two"></div>
          <div class="tariff-three"></div>
        </div>
      </div>
  </div>
</template>

<script>
    import baseUrl from '../../../tool/baseUrl';
    export default {
        name: "productShowDetail",
      data() {
          return {
              showType: 0,
              index: 1,
          };
      },
      methods: {
          handleOpen(index) {
            let that = this;
            if (!that.$$.checkLogin()) {
              that.$$.confirmLogin(this);
              return false;
            }

            switch (index) {
              case 1:{
                // 人寿团意险
                this.ls.removeItem('dynamicValidateForm')
                this.$router.push({name: 'insureManagement', query: {productId: "100414", planId: "1667" }});
                break;
              }
              case 2:{
                // 关税
                this.$router.push({name: 'dutyInsuranceFillInfo'});

                break;
              }
            }
          }
      },
      mounted() {
          //1是国寿财页面
          //2是关税页面
          this.showType = this.$route.params.showType;
      },
    }
</script>

<style scoped>

  .show{
    display: block;

  }
  .dis{
    display: none;
  }

  .life-top{
    max-height: 34.94rem;
    cursor: pointer;
    padding-top: 30%;
    background: url("../../../../static/images/productShowDetail/lifeInsurance/top.png") no-repeat center / cover;
  }

  .life-one{
    margin-top: 5rem;
    max-height: 40.67rem;
    padding-top: 34%;
    background: url("../../../../static/images/productShowDetail/lifeInsurance/one.png") no-repeat center / cover;
  }

  .life-two{
    width: 60%;
    text-align: center;
    margin: 0 auto 0 ;
    max-height: 47.16rem;
    padding-top: 38%;
    background: url("../../../../static/images/productShowDetail/lifeInsurance/two.png") no-repeat center / cover;
  }

  .life-three{
    margin-bottom: 5rem;
    max-height: 30.9rem;
    padding-top: 25%;
    background: url("../../../../static/images/productShowDetail/lifeInsurance/three.png") no-repeat center / cover;
  }


  .tariff-top{
    max-height: 32.5rem;
    cursor: pointer;
    padding-top: 29%;
    background: url("../../../../static/images/productShowDetail/tariff/top.png") no-repeat center / cover;
  }

  .tariff-one{
    margin-top: 100px;
    max-height: 48.59rem;
    padding-top: 40%;
    background: url("../../../../static/images/productShowDetail/tariff/one.png") no-repeat center / cover;
  }

  .tariff-two{
    margin-top: 100px;
    max-height: 56.23rem;
    padding-top: 47%;
    background: url("../../../../static/images/productShowDetail/tariff/two.png") no-repeat center / cover;
  }

  .tariff-three{
    width: 60%;
    text-align: center;
    margin: 0 auto;
    max-height: 30.06rem;
    padding-top: 25%;
    background: url("../../../../static/images/productShowDetail/tariff/three.png") no-repeat center / cover;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/productShowDetail.vue